
import $ from 'jquery'
import store_analyse from '@/store/mods/analyses/analyse'

export default {
    name: 'manage-prelevement',
    components: {},
    props: {
        one_is_checked: Array,
        toggler: Number
    },
    data() {
        return {
            is_confirm: false,
            save_loading: false,
            is_error: false,
            msg_error: ''
        }
    },

    watch: {
        toggler() {
            this.is_error = false
            this.is_confirm = false
            this.msg_error = ''
        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        submit(selector) {
            let confirm = document.getElementById(selector);

            if (!confirm.checked) { //  Vérifie si l'utilisateur a confirmé la suppression
                $('.err-msg').fadeIn(500)
                return
            }

            const data = {
                bulletin_ids: this.one_is_checked
            }

            this.save_loading = true
            store_analyse.savePrelevementsEffectues(data).then((response) => {
                if (response.success) {
                    this.successToast(response.message)
                    this.$emit('emitRefreshListePrelevement')
                    this.$refs.manage_prelevement.click()
                } else {
                    this.msg_error = response.message
                }
                this.save_loading = false;
                this.is_confirm = false
            }).catch(() => {
                this.save_loading = false
                this.msg_error = 'Une erreur s\'est produite lors de l\'enregistrement !'
            })
        }
    }
}